import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry

Description:
*/
import Immutable from 'immutable';
import { take, select, put } from 'redux-saga/effects';
import { getFormFields } from '../../selectors';
import { getErrorMessage } from '../../../fields/format';
import formIsValid from './support/form-is-valid';
import * as actions from '../actions';
import * as formActions from '../../forms/actions';
import { updateFormDependencies } from '../../form-dependencies/actions';
var watchExecuteCallbacks = /*#__PURE__*/regeneratorRuntime.mark(function watchExecuteCallbacks() {
  var _loop;

  return regeneratorRuntime.wrap(function watchExecuteCallbacks$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
            var _yield$take, formId, fields, fieldsRemapped, allUpdates;

            return regeneratorRuntime.wrap(function _loop$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return take(actions.FIELDS_EXECUTE_ONCHANGE_CALLBACKS);

                  case 2:
                    _yield$take = _context.sent;
                    formId = _yield$take.payload.formId;
                    _context.next = 6;
                    return select(getFormFields, formId);

                  case 6:
                    fields = _context.sent;
                    fieldsRemapped = fields.reduce(function (fields, field) {
                      return fields.set(field.fieldId, field);
                    }, Immutable.Map());
                    allUpdates = fields.filter(function (field) {
                      return field.onChangeCallback;
                    }).reduce(function (updates, field) {
                      var fieldKey = field.fieldKey,
                          fieldId = field.fieldId,
                          value = field.value,
                          dataType = field.dataType,
                          minLength = field.minLength,
                          required = field.required,
                          fieldName = field.labelText;
                      var defaultUpdates = {
                        fieldId: fieldId,
                        value: value,
                        dataType: dataType
                      };
                      var onChangePayload = {
                        updates: defaultUpdates,
                        fieldId: fieldId,
                        value: value,
                        field: field,
                        fields: fieldsRemapped
                      };
                      var fieldUpdates = (field.onChangeCallback(onChangePayload) || []).map(function (update) {
                        if (_typeof(field) === 'object') {
                          if (fieldId === field.fieldId) {
                            update.fieldKey = fieldKey;
                            update.errorMessage = update.errorMessage || getErrorMessage({
                              dataType: field.dataType || dataType,
                              value: update.value || value,
                              required: typeof field.required !== 'undefined' ? field.required : required,
                              minLength: typeof field.minLength !== 'undefined' ? field.minLength : minLength,
                              fieldName: update.labelErrorMsgOverride || fieldName
                            });
                          }

                          if (!update.errorMessage) {
                            update.showError = false;
                          }
                        }

                        return update;
                      });
                      return updates.concat(fieldUpdates);
                    }, []);
                    _context.next = 11;
                    return put(actions.applyFieldChanges(allUpdates));

                  case 11:
                    _context.next = 13;
                    return select(getFormFields, formId);

                  case 13:
                    fields = _context.sent;
                    _context.next = 16;
                    return put(formActions.changeForm({
                      formId: formId,
                      valid: formIsValid(fields)
                    }));

                  case 16:
                    _context.next = 18;
                    return put(updateFormDependencies({
                      formId: formId
                    }));

                  case 18:
                  case "end":
                    return _context.stop();
                }
              }
            }, _loop);
          });

        case 1:
          if (!true) {
            _context2.next = 5;
            break;
          }

          return _context2.delegateYield(_loop(), "t0", 3);

        case 3:
          _context2.next = 1;
          break;

        case 5:
        case "end":
          return _context2.stop();
      }
    }
  }, watchExecuteCallbacks);
});
export default watchExecuteCallbacks;